import { TriageFilterProvider } from "admin/components/diagnostics/TriageFilterContext";
import { TriageTable } from "admin/components/diagnostics/TriageTable";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { NEXTGEN_MAX_CONTENT_WIDTH } from "~/lib/layout";

export const SessionDiagnostics = () => {
  // N.B. No `useNextGenHeader` title: the nav picker pill already renders
  // "Session Diagnostics" immediately beside where the header title would go.
  useDocumentTitle("Session Diagnostics");

  return (
    <div
      className="mx-auto flex w-full flex-col gap-4 px-4 py-4"
      style={{ maxWidth: NEXTGEN_MAX_CONTENT_WIDTH }}
    >
      <p className="text-sm text-muted-foreground">Turn-level quality diagnostics and triage.</p>
      <TriageFilterProvider>
        {/* Rubric dimensions come from the diagnostics summary endpoint, which the backend
            doesn't implement yet, so the detail drawer falls back to raw dimension names. */}
        <TriageTable rubricDimensions={[]} />
      </TriageFilterProvider>
    </div>
  );
};
